(function (angular, document, parseInt) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyLazyLoadImg", function () {
    return {
      scope: {},
      restrict: "A",
      link: function ($scope, $element) {
        /*
         * This directive wraps an <img> element in a sized
         * placeholder (container element) so that when the
         * <img> src finally loads, the page doesn't jump.
         */

        /*
         * Note: there's no need to use this directive for a
         * background-image lazy load -- just add the CSS
         * class "lazyload" to the exact element(s) with the
         * background-image style applied.
         */

        var imageElement = $element[0];
        var imgWidth = parseInt(imageElement.dataset.tyLazyLoadImgWidth);
        var imgHeight = parseInt(imageElement.dataset.tyLazyLoadImgHeight);

        function wrap(el, wrapper) {
          el.parentNode.insertBefore(wrapper, el);
          wrapper.appendChild(el);
          return wrapper;
        }

        var wrapper = document.createElement("div");
        wrapper.className = "ty-lazy-load-placeholder";
        wrap(imageElement, wrapper);

        imageElement.className += " ty-lazy-load-placeholder__image";

        var imgParentStyles = imageElement.parentElement.style;

        if (!imgWidth || !imgHeight) {
          if (!imgWidth && imgHeight) {
            throw Error("tyLazyLoadImg: attribute data-ty-lazy-load-img-width is missing");
          } else if (imgWidth && !imgHeight) {
            throw Error("tyLazyLoadImg: attribute data-ty-lazy-load-img-height is missing");
          } else {
            throw Error(
              "tyLazyLoadImg: attributes data-ty-lazy-load-img-width and data-ty-lazy-load-img-height are missing"
            );
          }
        }

        var FRACTION_TO_PERCENT_MULTIPLIER = 100;
        var aspectRatio = imgHeight / imgWidth;
        imgParentStyles.paddingTop = aspectRatio * FRACTION_TO_PERCENT_MULTIPLIER + "%";
      },
    };
  });
})(window.angular, window.document, window.parseInt);
